/**
 * ユニサジェストAPIクライアント
 */
export default class UnisuggestApiClient {

  /** @type {string} APIベースURL */
  #baseUrl;

  /** @type {string} 履歴削除API用サービス名 */
  #serviceName;

  /**
   * コンストラクタ
   *
   * @param {string} baseUrl APIベースURL
   * @param {string} serviceName 履歴削除API用サービス名
   */
  constructor(baseUrl, serviceName) {
    this.#baseUrl = baseUrl.endsWith('/') ? baseUrl : baseUrl + '/';
    this.#serviceName = serviceName;
  }

  /**
   * ユニサジェストAPI呼び出し
   *
   * @param {UniSuggestApiRequest} params APIパラメータ
   * @returns {Promise<UniSuggestApiResponse|false>} APIレスポンス
   */
  async suggestSearch(params) {
    const suggestUrl = this.#baseUrl + 'qsuggest/v1d/asone/';
    const options = {
      method: 'GET',
      /** @type {UniSuggestApiRequest} */
      data: {
        kw: params.kw,
        loginid: params.loginid,
        uid: params.uid,
        history: params.history,
        rows: params.rows,
        dr_category: params.dr_category,
        dr_modelnumber: params.dr_modelnumber,
        dr_itemnumber: params.dr_itemnumber,
        dr_productname: params.dr_productname,
        dr_maker: params.dr_maker,
        dr_campaigntag: params.dr_campaigntag,
        fq_show_cd: params.fq_show_cd,
        wt: 'jsonp',
        hcli: this.#serviceName,
      },
      dataType: 'jsonp',
      jsonp: 'cbk',
    };
    try {
      const response = await $.ajax(suggestUrl, options);
      return response;
    } catch (error) {
      /* エラー処理 */
      const date = new Date().toJSON();
      const msg = params.kw
        ? `キーワード'${params.kw}'のサジェスト検索でエラーが発生しました。`
        : '履歴サジェストの取得でエラーが発生しました。';
      console.error(`${date} ${msg}`, {
        url: suggestUrl,
        error,
        params,
      });
      return false;
    }
  }

  /**
   * 履歴削除API
   *
   * @param {UniSuggestHistoryDeleteApiRequest} params APIパラメータ
   * @returns {Promise<UniSuggestHistoryDeleteApiResponse|false>} response レスポンス
   */
  async historyDelete(params) {
    const deleteUrl = `${this.#baseUrl}history_delete/v1d/${this.#serviceName}/`;
    const options = {
      method: 'GET',
      /** @type {UniSuggestHistoryDeleteApiRequest} */
      data: {
        loginid: params.loginid,
        uid: params.uid,
        wt: 'jsonp',
      },
      dataType: 'jsonp',
      jsonp: 'cbk',
    };
    try {
      const response = await $.ajax(deleteUrl, options);
      return response;
    } catch (error) {
      /* エラー処理 */
      const date = new Date().toJSON();
      console.error(`${date} 履歴削除時にエラーが発生しました。`, {
        url: deleteUrl,
        error,
        params,
      });
      return false;
    }
  }
}
